import { Component, OnInit } from '@angular/core';
import { TenantService } from '../services/tenant.service';
import { first } from 'rxjs/operators';

@Component({
    selector: 'slack-link-button',
    template: `
        <a *ngIf="!cannotLink"
            href="https://slack.com/oauth/authorize?scope={{scope}}&client_id={{clientId}}&redirect_uri={{redirectUri}}&state={{state}}">
            <img alt="Add to Slack" 
                 height="40" 
                 width="139" 
                 src="https://platform.slack-edge.com/img/add_to_slack.png" 
                 srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"/>
        </a>
        <span *ngIf="cannotLink">Linking to Slack does not work with Safari, please use Chrome, Firefox or Edge instead</span>
    `
})
export class SlackLinkButtonComponent implements OnInit {
    scope='channels:read,groups:read,mpim:read,im:read,channels:write,groups:write,mpim:write,im:write,chat:write:user,commands';
    clientId;
    redirectUri; 
    state;

    constructor(private tenantService: TenantService) {}

    ngOnInit(): void {
        this.state = window.location.href;
        this.tenantService.getCurrentTenant().pipe(first())
        .subscribe(tenant => {
            this.clientId = tenant.settings.slackClientId;
            this.redirectUri = `${tenant.settings.slackRedirectUri}/slack/link`;
        });
    }

    get cannotLink(): boolean {
        const ua = window['navigator'].userAgent.toLowerCase(); 
        return ua.indexOf('safari') != -1 && ua.indexOf('chrome') === -1;
    }
}